// pointingsReducers.js

// Action types
export const SET_POINTINGS_INFO = 'SET_POINTINGS_INFO';
export const UPDATE_POINTINGS_INFO = 'UPDATE_POINTINGS_INFO';
export const CLEAR_POINTINGS_INFO = 'CLEAR_POINTINGS_INFO';

// Initial state
const initialState = {
  pointingsInfo: JSON.parse(localStorage.getItem('pointingsInfo')) || {}, // Load from local storage if available
};

// Reducer function
const pointingsReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SET_POINTINGS_INFO:
      newState = setPointingsInfo(state, action.payload);
      break;
    case UPDATE_POINTINGS_INFO:
      newState = updatePointingsInfo(state, action.payload);
      break;
    case CLEAR_POINTINGS_INFO:
      newState = clearPointingsInfo();
      break;
    default:
      newState = state;
  }
  
  // Update local storage
  localStorage.setItem('pointingsInfo', JSON.stringify(newState.pointingsInfo));

  return newState;
};

// Action creators
export const setPointingsInfoAction = (pointingsInfo) => ({
  type: SET_POINTINGS_INFO,
  payload: { pointingsInfo },
});

export const updatePointingsInfoAction = (updatedInfo) => ({
  type: UPDATE_POINTINGS_INFO,
  payload: { updatedInfo },
});

export const clearPointingsInfoAction = () => ({
  type: CLEAR_POINTINGS_INFO,
});

// Helper functions
const setPointingsInfo = (state, payload) => {
  const { pointingsInfo } = payload;
  return { ...state, pointingsInfo: pointingsInfo };
};

const updatePointingsInfo = (state, payload) => {
  const { updatedInfo } = payload;
  return { ...state, pointingsInfo: { ...state.pointingsInfo, ...updatedInfo } };
};

const clearPointingsInfo = () => {
  return { ...initialState }; // Reset to initial state
};

export default pointingsReducer;
